import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  userObj: {},
  tempUser: false,
  database: null
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/login/vuex/index.js